import _classCallCheck from "C:\\Users\\Nehal\\Documents\\Projects\\230605LC_Fravo\\Fravo\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Nehal\\Documents\\Projects\\230605LC_Fravo\\Fravo\\node_modules\\@babel\\runtime/helpers/esm/createClass";
export var MotionReduce = /*#__PURE__*/function () {
  function MotionReduce() {
    _classCallCheck(this, MotionReduce);
    this.factor = 4;
    this.value = true;
  }
  _createClass(MotionReduce, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      if (data.factor !== undefined) {
        this.factor = data.factor;
      }
      if (data.value !== undefined) {
        this.value = data.value;
      }
    }
  }]);
  return MotionReduce;
}();